<template>
  <div
    class="modal"
    id="promotion-dialog"
    :style="myModalStyle"
    v-if="promotionDialog"
  >
    <div
      class="modal__header"
      :style="myHeaderStyle"
    >
      <v-layout
        row
        align-center
      >
        <v-flex xs2>
          <v-btn
            icon
            :color="theme.btn_color_primary"
            flat
            @click="closeDialog"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-flex>
        <v-flex
          xs10
          mr-1
          text-xs-right
        >
          <span class="name">{{ $t('item_voucher') }}</span>
        </v-flex>
      </v-layout>
    </div>
    <div
      class="modal__content"
      id="promotion-dialog-content"
      :style="myContentStyle"
      v-body-scroll-lock="promotionDialog"
    >
      <div v-if="promotionVoucher">
        <voucher-detail :voucher="promotionVoucher" />
      </div>
      <div
        class="text-xs-center mt-3"
        v-if="iOS && inIframe"
      >
        <v-btn
          flat
          dark
          :color="theme.btn_color_primary"
          @click="closeDialog"
        >
          Cancel
        </v-btn>
      </div>
    </div>
    <div
      class="modal__footer"
      :style="myFooterStyle"
    >
      <v-btn
        block
        dark
        large
        class="btn"
        :color="theme.btn_color_primary"
        @click="addToCart"
      >
        <v-layout row>
          <v-flex
            xs12
            class="text-xs-center"
          >
            {{ $t('add_to_cart') }}
          </v-flex>
        </v-layout>
      </v-btn>
    </div>
  </div>
</template>

<script>
import VueScrollTo from 'vue-scrollto'
import { mapGetters } from 'vuex'
import VoucherDetail from '~/components/VoucherDetail'

export default {
  name: 'menu-item-dialog-component',
  components: {
    'voucher-detail': VoucherDetail
  },
  computed: {
    ...mapGetters('config', [
      'theme', 'colors', 'iOS', 'inIframe'
    ]),
    ...mapGetters('menu', [
      'menuItem', 'menuItemPrice', 'menuItemQty',
      'menuItemReady', 'menuItemCourseItems', 'menuItemOptions',
      'menuItemToppings', 'itemStatus', 'menuItemRequired'
    ]),
    ...mapGetters('voucher', [
      'promotionDialog', 'promotionVoucher', 'promotionItem', 'vouchers',
      'allVouchers'
    ]),
    ...mapGetters('cart', [
      'cartAmount', 'cart'
    ]),
    myModalStyle () {
      return {
        backgroundColor: this.theme.menu_bg_color
      }
    },
    myHeaderStyle () {
      return {
        backgroundColor: this.theme.bg_color
      }
    },
    myContentStyle () {
      return {
        position: 'absolute',
        bottom: '64px',
        top: '48px',
        backgroundColor: this.theme.menu_bg_color
      }
    },
    myFooterStyle () {
      return {
        position: 'absolute',
        bottom: 0,
        backgroundColor: this.theme.menu_bg_color
      }
    },
    myQtyStyle () {
      return {
        color: this.theme.menu_qty_color
      }
    }
  },
  methods: {
    closeDialog () {
      this.$store.dispatch('voucher/hidePromotionDialog')
      if (this.iOS && this.inIframe) {
        if (this.$route.params.return === 'order') {
          this.$router.push({ name: 'order', params: { id: this.$route.params.id }})
        } else {
          this.$router.push({ name: this.$route.params.return })
        }
      }
    },
    async addToCart () {
      if (this.rInfoExpiredAlert()) {
        return
      }
      if (this.cart.find(item => item.voucher_id === this.promotionVoucher.voucher_id)) {
        const text = 'You already used this voucher in your basket.'
        this.$store.dispatch('responseMessage', {
          type: 'error',
          title: 'One redemption per member',
          text: text,
          modal: true
        })
        return
      }
      const gv = this.promotionVoucher.gems_member_voucher
      if (parseInt(gv.VoucherType) === 1) {
        if (this.menuItemReady === null) {
          await this.$store.dispatch('menu/processMenuItem', 'both')
        }
        if (this.menuItemReady === false) {
          this.$store.dispatch('responseMessage', {
            type: 'error',
            text: 'Please select: ' + this.menuItemRequired.join(', '),
            title: 'Please complete selection',
            modal: true
          })
          const options = {
            container: '#promotion-dialog-content',
            easing: 'ease-in',
            offset: -20,
            force: true,
            cancelable: false,
            x: false,
            y: true
          }
          const element = '#' + this.menuItemRequired[0].replace(/\s+/g, '-').toLowerCase()
          VueScrollTo.scrollTo(element, 500, options)
          return
        }
        const params = {
          voucher_id: this.promotionVoucher.voucher_id,
          member_voucher_id: this.promotionVoucher.id,
          item: this.menuItem,
          quantity: this.menuItemQty,
          final_price: this.menuItemPrice,
          options: this.menuItemOptions,
          toppings: this.menuItemToppings,
          set_course_items: this.menuItemCourseItems
        }
        await this.$store.dispatch('cart/addCartItem', params)
        this.$store.dispatch('voucher/hidePromotionDialog')
        if (this.iOS && this.inIframe) {
          if (this.$route.params.return === 'order') {
            this.$router.push({ name: 'order', params: { id: this.$route.params.id }})
          } else {
            this.$router.push({ name: this.$route.params.return })
          }
        }
      } else {
        await this.$store.dispatch('cart/addCartVoucher', this.promotionVoucher.voucher_id)
        this.$store.dispatch('voucher/hidePromotionDialog')
        if (this.iOS && this.inIframe) {
          if (this.$route.params.return === 'order') {
            this.$router.push({ name: 'order', params: { id: this.$route.params.id }})
          } else {
            this.$router.push({ name: this.$route.params.return })
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.modal {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 200;
}
.modal__header {
  height: 48px;
}
.modal__footer {
  width: 100%;
  height: 64px;
  padding: 0 10px;
}
.modal__content {
  width: 100%;
  overflow-y: auto;
  padding: 10px 24px;
}
.btn {
  margin: 10px 0;
}
.name {
  padding-right: 16px;
}
</style>




// WEBPACK FOOTER //
// src/components/PromotionDialog.vue